import React, { useState } from "react"
import { FComprasStyle } from "./styles"
import useCatalogo from "./../../../hooks/useCatalogos"
import { useFormik } from "formik"
import TextField from "@material-ui/core/TextField"
import {
  Button,
  Grid,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  InputAdornment
} from "@material-ui/core"
import BackDrop from "./../../../global/BackDrop"
import * as yup from "yup"

const validationSchema = yup.object({
  nombreCompra: yup.string("Ingresa un nombre").required("Nombre es requerido"),
  costoProveedor: yup
    .string("Ingresa una descripción")
    .required("Descripcion es requerido"),
  comisionProveedor: yup
    .number("Ingresa numeros")
    .required("Impuesto es requerido"),
  comisionDooddo: yup.number("Ingresa numeros").required("Tarifa es requerido"),
})


const FCompras = () => {

  const InitalValues = {
    nombreCompra: "",
    costoProveedor: 0,
    comisionProveedor: 0,
    comisionDooddo: 0,
  }

  const classes = FComprasStyle()
  const catalogoTipoMoneda = useCatalogo("MonedaProveedor");
  const [tipoMoneda, setTipoMoneda] = useState(0)
  const [descMoneda, setDescMoneda] = useState("")
  const [isLoad, setIsLoad] = useState(false)

  const formik = useFormik({
    initialValues: InitalValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setIsLoad(true)
      LimpiarForm()

    },
  })

  const LimpiarForm = () => {
    formik.resetForm(InitalValues);
  }

  const handleSelecTipoMoneda = (event) => {
    setTipoMoneda(event.target.value);
    setDescMoneda(catalogoTipoMoneda.find(moneda => moneda.IdMoneda === event.target.value).Clave)
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container className={classes.containerSpacing}>
      <Grid item xs={12}>
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="lTipoCompra">Tipo compra</InputLabel>
            <Select
              labelId="lTipoCompra"
              id="STipoCompra"
              name="tipoCompra"
              value={"0"}
              onChange={(event) => {}}
              label="Tipo compra"
            >
              <MenuItem value="0" disabled>
                {"Seleccione una opción"}
              </MenuItem>
              {[].map((moneda, index) => (
                <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                  {`${moneda.Clave} - ${moneda.Descripcion}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="input-Nombre"
            label="Nombre de la compra"
            type="text"
            variant="outlined"
            name="nombreCompra"
            value={formik.values.nombreCompra}
            onChange={formik.handleChange}
            error={formik.touched.nombreCompra && Boolean(formik.errors.nombreCompra)}
            helperText={formik.touched.nombreCompra && formik.errors.nombreCompra}
            className={classes.textField}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            id="txtCostoProveedor"
            label="Cosoto proveedor"
            type="text"
            variant="outlined"
            name="costoProveedor"
            value={formik.values.costoProveedor}
            onChange={formik.handleChange}
            error={
              formik.touched.costoProveedor && Boolean(formik.errors.costoProveedor)
            }
            helperText={formik.touched.costoProveedor && formik.errors.costoProveedor}
            className={classes.textField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  {descMoneda}
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="lTipoMoneda">Moneda</InputLabel>
            <Select
              labelId="lTipoMoneda"
              id="STipoMoneda"
              name="tipoMoneda"
              value={tipoMoneda}
              onChange={handleSelecTipoMoneda}
              label="Moneda"
            >
              <MenuItem value="0" disabled>
                {"Seleccione una opción"}
              </MenuItem>
              {catalogoTipoMoneda.map((moneda, index) => (
                <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                  {`${moneda.Clave} - ${moneda.Descripcion}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            id="input-comisionProveedor"
            label="Comision Proveedor"
            type="text"
            variant="outlined"
            name="comisionProveedor"
            value={formik.values.comisionProveedor}
            onChange={formik.handleChange}
            error={formik.touched.comisionProveedor && Boolean(formik.errors.comisionProveedor)}
            helperText={formik.touched.comisionProveedor && formik.errors.comisionProveedor}
            className={classes.textField}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            id="input-comisionDooddo"
            label="Comision Dooddo"
            type="text"
            variant="outlined"
            name="comisionDooddo"
            value={formik.values.comisionDooddo}
            onChange={formik.handleChange}
            error={formik.touched.comisionDooddo && Boolean(formik.errors.comisionDooddo)}
            helperText={formik.touched.comisionDooddo && formik.errors.comisionDooddo}
            className={classes.textField}
          />
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.modalBoton}
          >
            {"Guardar"}
          </Button>
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </form>
  );
};
export default FCompras;
